import React from 'react';
import PropTypes from 'prop-types';
import ConfettiExplosion from 'react-confetti-explosion';

const FullScreenExplosion = ({ active }) => {
    if (!active) return null;

    return (
        <div
            style={{
                position: 'fixed',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                zIndex: 9999,
                pointerEvents: 'none',
            }}
        >
            <ConfettiExplosion
                force={0.9}
                duration={5000}
                particleCount={100}
                width={1600}
            />
        </div>
    );
};
FullScreenExplosion.propTypes = {
    active: PropTypes.bool.isRequired,
};
export default FullScreenExplosion;
